<div class="flex min-h-screen items-center justify-center bg-gray-50 p-4">
  <router-outlet></router-outlet>
</div>
